import styled from 'styled-components';

// CONSTANTS
import colors from '@/constants/colors';
import { breakpoints } from '@/utility/breakpoints';

export const RatingsContent = styled.div`
  padding-top: 65px;
  display: flex;
  text-align: center;

  ${breakpoints.down('sm')} {
    flex-direction: column;
    align-items: center;
  }

  .ratings-content {
    &__section {
      margin-right: 30px;
      display: flex;
      flex-direction: column;

      &:last-of-type {
        margin-right: 0;
      }

      ${breakpoints.down('sm')} {
        margin-right: 0;
        margin-bottom: 30px;
        align-items: center;

        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }

    &__mark {
      font-size: 9rem;
      line-height: 9rem;
      font-weight: 600;
      margin: 0;
    }

    &__count {
      color: ${colors.textSecondary};
      margin-top: 10px;
      margin-bottom: 0;
      line-height: 1;
    }

    &__picking {
      padding: 0;
      margin: 0;
      list-style: none;
      width: 100%;

      .picking-item {
        display: flex;
        align-items: center;
        width: 100%;
        margin-bottom: 10px;

        &:last-of-type {
          margin-bottom: 0;
        }

        &__mark {
          width: 10px;
          text-align: center;
        }

        &__count,
        &__mark {
          color: ${colors.textSecondary};
        }

        &__progress {
          width: 200px;
          padding: 0px 6px;
        }
      }
    }
  }
`;

export const RatingContent = styled.div`
  ${breakpoints.down('sm')} {
    text-align: center;
  }
`;

export const WriteReviewContent = styled.div`
  padding-top: 60px;

  ${breakpoints.down('sm')} {
    padding-top: 40px;
  }

  .write-review {
    &__rating {
      margin-top: 25px;
    }
  }
`;

export const ReviewsContent = styled.div`
  .reviews-content {
    &__wrapper {
      &:first-of-type {
        .reviews-content__review {
          padding-top: 0;
        }
      }

      &:last-of-type {
        .MuiDivider-root {
          display: none;
        }

        .reviews-content__review {
          padding-bottom: 0;
        }
      }
    }

    &__filters {
      margin-bottom: 40px;
    }

    &__review {
      padding: 40px 0;
    }

    &__date {
      margin-left: 10px;
      color: ${colors.textSecondary};
    }

    &__empty {
      margin-top: 12px;
    }
  }
`;

export default RatingsContent;
